import type { JSX } from 'react'
import { ADVISOR_ENABLED } from './config'
import { AdvisorPanel } from './ui/AdvisorPanel'

export { AdvisorPanel } from './ui/AdvisorPanel'
export { ADVISOR_ENABLED } from './config'

export function AdvisorMount(): JSX.Element | null {
  return ADVISOR_ENABLED ? <AdvisorPanel /> : null
}
